// extracted by mini-css-extract-plugin
module.exports = {"bd":"bd-1J97Xy4s","space40":"space40-21mlWjfh","space10":"space10-2SprXtOF"};